import script from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"

export default script